<template>
    <div class="map map-outdoor mapboxgl-map" id="mapOutdoor">
        <div v-if="!readOnlyMode" class="absolute bottom-2 right-2 z-10">
            <UiSwitch
                v-model="displayMapVecto"
                :labelYes="$t('plans.mapstyles.vecto')" 
                :labelNo="$t('plans.mapstyles.sat')"
                style="width: 200px; box-shadow: var(--shadows-base);"
            />
        </div>
        <div class="marker marker-ghost" id="marker-ghost" style="width: 50px;height: 50px;position: absolute;z-index: 100;pointer-events: none;top: -50px; left: -50px;display: none;">
            <img :src="markerWifi" style="width: 50px;height: 50px;"/>
        </div>
        <div class="marker-popup" style="position: absolute;z-index: 100;pointer-events: none;top: -50px; left: -50px;display:none;">
        </div>
    </div>
</template>

<script>
    const markerWifi = require('@/assets/img/marker-wifi.png');
    const markerBluetooth = require('@/assets/img/marker-bluetooth.png');
    const markerNFC = require('@/assets/img/marker-nfc.png');
    const markerQRCode = require('@/assets/img/marker-qrcode.png');

    import MapService from '@/services/map.js';
    import Btn from '@/components/ui/Button';
    import UiSwitch from '@/components/ui/Switch';
    import {Map} from '@/components/plans/map/MapClass';

    export default {
        components: {
            Btn,
            UiSwitch,
        },
        computed: {
            markerWifi: function(){
                return markerWifi;
            },
            displayMapStyle: function(){
                return this.mapStyles[this.displayMapVecto ? 0 : 1];
            }
        },
        data () {
            return {
                map: null,
                draw: null,
                defaults: {
                    center: [1.87635, 46.60559],
                    zoom: 5
                },
                centerI: [1.87635, 46.60559],
                zoomI: 5,
                easeDuration: 1000,
                mapStyles: [
                    'mapbox://styles/mapbox/streets-v12',
                    'mapbox://styles/mapbox/satellite-streets-v12'
                ],
                displayMapVecto: true,
            }
        },
        methods: {
            reset: function () {
                this.map._map.flyTo({center: this.defaults.center, zoom: this.defaults.zoom, speed: 1});

            },
            drawEditMode: function (drawMode,feature) {
                var vThis = this;

                var drawing = {
                    "id": feature.id,
                    "type": "Feature",
                    "properties": feature,
                    "geometry": {
                        "coordinates": JSON.parse(feature.polygon),
                        "type": "Polygon"
                    }
                }


                this.map.switchEditDrawMode(true,drawing,function(drawn){
                    vThis.$emit('groupEdited', drawn);
                    vThis.map.switchEditDrawMode(false);
                })
            },
            drawMode: function (drawMode) {
                var vThis = this;

                this.map.switchDrawMode(true,function(drawn){
                    vThis.$emit('groupDrawn', drawn);
                    vThis.map.switchDrawMode(false);
                })
            },

            showGroup: function (group) {

                var drawing = {
                    "id": group.id,
                    "type": "Feature",
                    "properties": group,
                    "geometry": {
                        "coordinates": JSON.parse(group.polygon),
                        "type": "Polygon"
                    }
                }

                this.map.addPolygon(drawing);

                var bounds = MapService.getBounds(drawing.geometry.coordinates[0]);

                this.map._map.fitBounds(bounds);

            },

            clearDraw: function () {
                this.map.clearFeatures();
            },

            setStyle: function (isVecto) {
                var that = this;
                this.map._map.setStyle(this.mapStyles[isVecto ? 0 : 1]);
                this.map._map.on('style.load', function() {
                    that.map.initLayers();
                });
            },

            setDD: function(){
                this.map.addDragAndDrop(this.handleDrop);
                this.map.addPopup()
            },
            mapLoaded: function(e){
                this.$emit('loaded');
            },
            handleDrop: function(node,position){
                this.$emit('markerMoved',node, position);
            },
            flyTo: function(center, zoom){
                this.map._map.flyTo({center: center, zoom: zoom, speed: 1.5});
            },

        },
        mounted: function () {
            var vThis = this;

            //this.map = Map.init('mapOutdoor', Map.MAP_TYPES.OUTDOOR, this.center, this.zoom);
            var mapConfig =
                {
                        logoPosition: 'top-left',
                        attributionControl: false,
                        style: 'mapbox://styles/mapbox/streets-v12',
                        center: [1.87635,46.60559],
                        zoom: 5,
                        maxZoom: 22
                };
            let map = new Map('mapOutdoor',mapConfig,this.mapLoaded);

            this.map = map;


        },
        name: 'outdoormap',
        props: {
            center: {
                type: Array,
                default: function () {
                    return [(1.410 / 2), (-0.885 / 2)];
                },
            },
            zoom: {
                type: Number,
                default: 9,
            },
            data: {
                type: [Object],
                default: function () {
                    return {};
                }
            },
            readOnlyMode: {
                type: Boolean,
                default: false
            }
        },
        watch: {

            center: function () {
                this.map._map.flyTo({center: this.center, zoom: this.zoom+0.5, speed: 1.5});

            },
            zoom: function (newValue, oldValue) {
                this.map._map.flyTo({center: this.center, zoom: (newValue+0.5 || this.defaults.zoom), speed: 1.5});
            },
            data: function(newValue){
                this.map.addGeoJson(newValue);
            },
            displayMapVecto: function(newValue){
                this.setStyle(newValue);
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>

